import {initializeApp} from "firebase/app";
import {getFirestore} from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAxe_nwn8-VCsxJ0-mban0ZSXbkRs5t0Lk",
  authDomain: "makana-impact.firebaseapp.com",
  projectId: "makana-impact",
  storageBucket: "makana-impact.firebasestorage.app",
  messagingSenderId: "706343968884",
  appId: "1:706343968884:web:ce379fbd61f0e0c1c0f41"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);